import {
  colors as Colors,
  space as Space,
  fontWeights as FontWeights,
  textStyles as TextStyles,
  shadows,
} from './semantic';

export interface SemanticTokens {
  colors: typeof Colors;
  space: typeof Space;
  fontWeights: typeof FontWeights;
  textStyles: typeof TextStyles;
  shadows: typeof shadows;
}

export const semanticTokens: SemanticTokens = {
  colors: Colors,
  space: Space,
  fontWeights: FontWeights,
  textStyles: TextStyles,
  shadows: shadows,
};
